import { render, staticRenderFns } from "./KlaviyoSettings.vue?vue&type=template&id=400e0077"
import script from "./KlaviyoSettings.vue?vue&type=script&lang=js"
export * from "./KlaviyoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports